import Page from '../../class/Page';
import BootstrapCarousel from 'bootstrap/js/dist/carousel';

window.pageCurrent = class extends Page {
    init() {
        super.init();

        this.app.gtm.trigger('view_item', appData.page.vars.gtmData);

        if (document.getElementById('course-booking')) {
            this.app.vue.buildSingleComponent(
                document.getElementById('course-booking'),
                require('./vue/Booking.vue')
            );
        }

        document
            .querySelectorAll('.course-images img')
            .forEach((i) =>
                i.addEventListener('click', (evt) =>
                    evt.target.requestFullscreen({ navigationUI: 'show' })
                )
            );
    }
};
